// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyA9CLQYol-h5qBrtreO4hk8Ly71xo4oNM8",
    authDomain: "panaderia-11e32.firebaseapp.com",
    projectId: "panaderia-11e32",
    storageBucket: "panaderia-11e32.firebasestorage.app",
    messagingSenderId: "1092756433367",
    appId: "1:1092756433367:web:ed076d1ffc34a3a5244392",
    measurementId: "G-D3ZWXZ9NFT"
  };
  
    export default firebaseConfig;